"use client"
import React, { useEffect, useState, useRef } from "react";
import Styles from "./textCycler.module.scss";
interface TextCyclerProps {
  items: {
    id: string;
    text: string;
  }[];
  delay?: number; // milliseconds
  loop?: boolean;
  className?: string;
}

const TextCycler: React.FC<TextCyclerProps> = ({
  items,
  delay = 3000,
  loop = true,
  className = "",
}) => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const transitioningRef = useRef(false);

  useEffect(() => {
    if (items.length === 0) return;
    if (!visible && !transitioningRef.current) {
      transitioningRef.current = true;
    }
    if (visible) {
      timeoutRef.current = setTimeout(() => setVisible(false), delay);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [index, items.length, delay, visible]);

  const handleTransitionEnd = () => {
    if (!visible && transitioningRef.current) {
      setIndex((prev) => {
        if (prev + 1 < items.length) return prev + 1;
        return loop ? 0 : prev;
      });
      setVisible(true);
      transitioningRef.current = false;
    }
  };

  if (items.length === 0) return null;

  return (
    <div
      className={`${Styles.textCyclerOverlay} ${className}`}
      style={{ transition: "opacity 0.6s", opacity: visible ? 1 : 0 }}
      onTransitionEnd={handleTransitionEnd}
    >
      <span className={`${Styles.textCyclerText}`}>
        {items[index].text }
      </span>
    </div>
  );
};

export default TextCycler;
